








































import { Component } from 'vue-property-decorator';

import FiltrosBusqueda from '@/pantallas/SucursalVirtual/MisVisitas/FiltrosBusqueda.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import { LoadingService } from '@/services/loadingService';
import TablaMisVisitas from './TablaMisVisitas.vue';
import ExportCsv from './ExportCsv.vue';
import moment from 'moment';
import {
  ValueFormatterParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import WidgetUser from '@/pantallas/SucursalVirtual/WidgetUser.vue';
import {
  fetchSertec,
  getEstadosSertec,
} from '@/pantallas/SucursalVirtual/MisVisitas/fetchSertec';
import {
  ConfigEmpresas,
  fetchEmpresas,
  fetchMS,
} from '@/pantallas/SucursalVirtual/NuevaSolicitud/fetchConfigInicial';
import Analitica from '@/pantallas/SucursalVirtual/analitica_uso';

@Component({
  components: {
    FiltrosBusqueda,
    WidgetUser,
    TablaMisVisitas,
    ExportCsv,
  },
})
export default class MisVisitas extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.MisVisitas;
  analytic = new Analitica(122, window.location.href);

  visitas: any[] = [];
  listaEmpresas: ConfigEmpresas[] = [];
  loadingService: LoadingService = new LoadingService();
  listaEstados: any[] = [];
  listaPatentes: any[] = [];
  defaultEstado: number = 140390003;
  defaultPatente: number = 0;
  filtrobusquedagrilla: string = '';
  showExport: boolean = false;
  loadingPatente: boolean = false;
  requestsStart: number = 0;
  rutClienteDefecto: string = JSON.parse(window.localStorage.user)
    .rutClienteDefecto;
  activos: string[] = [];
  categoriaUsuario: string = null;

  constructor() {
    super();
  }

  async mounted() {
    let entrada = await this.analytic.entrada();
    this.getCategoriaUsuario();
    console.log(this.categoriaUsuario);
    if (this.categoriaUsuario == 'Interno') {
      this.getEmpresas();
    }
    //this.getEmpresas();
    this.getEstadosVisitas();
  }
  async destroyed() {
    let salida = await this.analytic.salida(this.analytic.id_analitica);
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) this.loadingService.showLoading();
  }

  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) this.loadingService.hideLoading();
  }

  async VisitaInicial() {}

  async buscarSertec(
    idcliente: string,
    estado: string,
    id_user: string,
    patente: string,
    fechaInicio: string,
    fechaFin: string
  ) {
    try {
      this.loadingService.showLoading(undefined, 'buscarSertec');
      let MsResponseData =
        (await fetchSertec(
          idcliente,
          estado,
          id_user,
          patente,
          fechaInicio,
          fechaFin
        )) || null;
      if (MsResponseData !== null && MsResponseData.status == 200) {
        let MsData = MsResponseData.data;
        if (MsData['CODIGO_RESPUESTA'] == '1') {
          if (MsData['data'].length > 0) {
            this.visitas = MsData['data'];
            this.showExport = true;
          } else {
            this.visitas = [];
            this.showExport = false;
            this.$snotify.error('No se han encontrado registros.', {
              timeout: 3000,
            });
          }
        } else {
          this.visitas = [];
          this.showExport = false;
          this.$snotify.error(MsData['MENSAJE_RESPUESTA'], {
            timeout: 3000,
          });
        }
      } else {
        this.visitas = [];
        this.showExport = false;
        this.$snotify.error('Ocurrió un error. Intente nuevamente', {
          timeout: 3000,
        });
      }
    } catch (err) {
      this.$snotify.error(
        this.$t('mensajes.mensajesError.consulta', {
          entidad: 'las visitas',
        })
      );
    } finally {
      this.loadingService.hideLoading('buscarSertec');
    }
  }

  /*async getEmpresas() {
    try {
      this.loadingService.showLoading(undefined, 'getEmpresas');
      let empresasResponse = (await fetchEmpresas()) || [];
      this.listaEmpresas = empresasResponse.filter(x => x.id != '');
    } catch (error) {
      if (error.message == 'Network Error')
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las empresas',
          { timeout: 3000 }
        );
      else if (error.response.status != 404)
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las empresas',
          { timeout: 3000 }
        );
    } finally {
      this.loadingService.hideLoading('getEmpresas');
    }
  }*/
  async getEmpresas() {
    this.loadingService.showLoading(undefined, 'getEmpresas');
    let r: any = [];
    r = (await this.cargarEmpresas()) || [];
    r = r['data'];
    console.log(r);
    if (r['CODIGO_RESPUESTA'] == '1') {
      this.listaEmpresas = r['data'];
      console.log(this.listaEmpresas);
    } else {
      this.$snotify.error(r['MENSAJE_RESPUESTA'], { timeout: 3000 });
    }
  }
  cargarEmpresas() {
    return fetchMS({}, 'track/get_ListadoCuentas_sc')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener el listado de cuentas',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener el listado de cuentas',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.loadingService.hideLoading('getEmpresas'));
    //this.loadingService.showLoading();
    /*return fetchEmpresas().catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las empresas',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las empresas',
          { timeout: 3000 }
        );
      }
    });*/
    //.finally(() => this.loadingService.hideLoading());
  }

  filtroVisitas(filtros: any) {
    if (this.categoriaUsuario == 'Interno' && filtros.empresa.value == '') {
      this.$snotify.error('Debe seleccionar una empresa', { timeout: 3000 });
      return false;
    }
    if (filtros.estado.value == '') {
      this.$snotify.error('Debe seleccionar un estado', { timeout: 3000 });
      return false;
    }
    let clienteDefecto = '';
    if (this.categoriaUsuario == 'Interno') {
      clienteDefecto = filtros.empresa.value;
    } else {
      clienteDefecto = JSON.parse(window.localStorage.user).rutClienteDefecto;
    }

    this.buscarSertec(
      clienteDefecto,
      filtros.estado.value,
      JSON.parse(window.localStorage.user).id,
      filtros.patente.value,
      filtros.fechaInicio.value,
      filtros.fechaFin.value
    );
  }

  async getEstadosVisitas() {
    let MsResponseData = (await this.cargarEstados()) || null;
    if (MsResponseData !== null && MsResponseData.status == 200) {
      let MsData = MsResponseData.data;
      if (MsData['CODIGO_RESPUESTA'] == '1') {
        if (MsData['data'].length > 0) {
          this.listaEstados = MsData['data'];
        } else {
          this.listaEstados = null;
          this.$snotify.error('Error al obtener estados', {
            timeout: 3000,
          });
        }
      } else {
        this.listaEstados = null;
        this.$snotify.error(MsData['MENSAJE_RESPUESTA'], {
          timeout: 3000,
        });
      }
    } else {
      this.listaEstados = null;
      this.$snotify.error('Ocurrió un error. Intente nuevamente', {
        timeout: 3000,
      });
    }
  }

  cargarEstados() {
    this.showLoading();
    return getEstadosSertec().catch(error => {
      if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener los tipos de Giros',
          { timeout: 3000 }
        );
      }
    });
  }

  async getCategoriaUsuario() {
    let configOK = JSON.parse(window.localStorage.user).configOKSucursal;
    if (!configOK){
      this.$snotify.warning(
        'Usuario sin Sucursal Virtual activa en CRM',
        { timeout: 10000 }
      );
    }

    let categoria = JSON.parse(window.localStorage.user).categoria;
    if (categoria !== undefined) {
      console.log(
        'retorno categoria desde localStorage categoria=' + categoria
      );
      this.categoriaUsuario = categoria;
    } else {
      let r: any = [];
      r =
        (await this.fetchCategoriaUsuario(
          JSON.parse(window.localStorage.user).email
        )) || [];
      r = r['data'];
      if (r['CODIGO_RESPUESTA'] !== '1') {
        this.$snotify.error(r['MENSAJE_RESPUESTA'], { timeout: 3000 });
        this.categoriaUsuario = 'Externo';
        console.log(this.categoriaUsuario);
      } else {
        categoria = r['categoria'];
        console.log('retorno categoria desde MS categoria=' + categoria);
        this.categoriaUsuario = categoria;
        if (this.categoriaUsuario == 'Interno') {
          this.getEmpresas();
        }
        if (!r['config_ok_sucursal']){
          this.$snotify.warning(
            'Usuario sin Sucursal Virtual activa en CRM',
            { timeout: 10000 }
          );
        }
      }
    }
  }
  fetchCategoriaUsuario(mail: string) {
    return fetchMS({ email: mail }, 'track/get_categoria_sc').catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categorias',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categoriasp',
          { timeout: 3000 }
        );
      }
    });
  }

  //searchDataEmpresa(a: string) {
  //  this.searchDataActivos(a);
  //}

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }

  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }

  /* TODO: para que se usan estas 4 variables?? */
  accionVerPdf: PermisoAccion = {
    accionCodigo: 89,
    visible: false,
  };
  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };
  accionDescargar: PermisoAccion = {
    accionCodigo: 10,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [];
}
